<template>
  <aside v-if="items.length" class="banner-card-wrap">
    <a
      v-if="!content.ads"
      :href="content.link"
      target="_blank"
      class="banner-card d-flex"
    >
      <img
        :src="files + content.img"
        :alt="content.title"
        :title="content.title"
        loading="lazy"
        class="banner-card-image"
      />
    </a>
    <div v-else v-html="content.ads"></div>
  </aside>
</template>

<script>
const types = {
  top: 1,
  "center-1-a": 2,
  "center-1-b": 3,
  "center-2": 4,
  "right-a": 5,
  "bottom-a": 6,
  "bottom-b": 7,
  "right-b": 8,
};
const time = 5000;

export default {
  props: {
    type: {
      type: String,
      required: true,
      validator: (v) => Object.keys(types).includes(v),
    },
  },
  data: () => ({
    i: 0,
    interval: null,
  }),
  computed: {
    items() {
      const items = this.$rest("banners").list.filter(
        ({ category: { id } }) => id === types[this.type]
      );

      return items.slice(0, 1);
    },
    content() {
      return this.items[this.i] || {};
    },
  },
  methods: {
    start() {
      if (this.interval) return;
      if (this.items.length > 1) {
        this.interval = setInterval(() => {
          if (this.i + 1 === this.items.length) this.i = 0;
          else this.i++;
        }, time);
      }
    },
    loadAds() {
      if (window.loadAdsInterval) return;

      window.loadAdsInterval = setInterval(() => {
        try {
          if (!window.adsbygoogle) {
            const script = document.createElement("script");
            script.src =
              "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
            document.body.appendChild(script);

            (window.adsbygoogle || []).push({});
          } else {
            window.adsbygoogle.push({});
          }
        } catch {
          return;
        }
      }, 1000);

      return this.content.ads;
    },
  },
  watch: {
    items() {
      this.start();
      this.loadAds();
    },
  },
  mounted() {
    this.start();
    this.loadAds();
  },
};
</script>

<style>
.banner-card-wrap {
  overflow: hidden;
}
.banner-card {
  width: 100%;
  max-width: 100vw;
}
.banner-card-image {
  object-fit: contain;
  width: 100%;
}
.banner-card-wrap .adsbygoogle {
  display: block !important;
  margin: 0 auto;
  max-width: 100%;
}
</style>
